import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from '../Navigation/Navigation'
import AuthorizationFilter from '../Authorization/AuthorizationFilter'
import DetailRow from '../../components/StaticDetailList/DetailRow'
import EmailCell from '../../components/StaticDetailList/EmailCell'
import PhoneCell from '../../components/StaticDetailList/PhoneCell'
import LinkCell from '@isceco/widget-library2/basic-elements/List/cell/LinkCell.js'
import GPDto from '../Geschaeftspartner/GPDto'
import VerfuegungVersandKonfigDto from "../Geschaeftspartner/VerfuegungVersandKonfigDto";
import StaticRow from "@isceco/widget-library2/basic-elements/List/StaticRow.js";
import GPService from "../Geschaeftspartner/GPService";
import VerfuegungVersandKonfigColumns from "./VerfuegungVersandKonfigColumns";
import EditableCell from "../../components/StaticDetailList/EditableCell";
import StringCell from "@isceco/widget-library2/basic-elements/List/cell/StringCell";

import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/List/StaticList'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/RadioGroup/RadioGroup'
import '../../components/StaticDetailList/StaticDetailList'
import '../Dashboard/GP/GPVerfuegungSetup'

export default class GPStammdaten extends WebComponent {
  static get properties() {
    return {
      geschaeftspartner: {type: GPDto}
    }
  }

  constructor() {
    super()
    this.gpService = new GPService()
  }

  get translationFile() {
    return './views/GPDetail/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.resolve(
      this.gpService.list(`${getNavigationId()}/verfuegungversand`)
    ).then(jsonList => {
      this.versandKonfigs = jsonList.map(json => new VerfuegungVersandKonfigDto(json))
      super.reload()
    })
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('gp.stammdaten.title')}"></isceco-title>
      <eko-static-detail-list .data="${this.getListData()}"></eko-static-detail-list>
      ${this._renderVersandKonfigs()}
      ${this._renderEditSpracheDialog()}
    `
  }

  _renderVersandKonfigs() {
    return this.versandKonfigs.length === 0 ? html`` : html`
      <isceco-title size="medium" text="${this.i18n.translate('gp.stammdaten.versandKonfig.title')}">
        ${this._renderVersandKonfigsButton()}
      </isceco-title>
      <isceco-static-list id="versand-konfig-list"
                          .i18n="${this.i18n}"
                          .columns="${VerfuegungVersandKonfigColumns.getColumns(this.downloadVerfuegungKonfig)}"
                          .data="${this.versandKonfigs.map(config => new StaticRow(config))}"
      ></isceco-static-list>
      ${this._renderVersandKonfigDialog()}
    `
  }

  _renderVersandKonfigsButton() {
    if (new AuthorizationFilter().roles.GP) {
      return html`
        <isceco-button icon="pencil alternate" size="small"
                       title="${this.i18n.translate('gp.stammdaten.versandKonfig.edit.tooltip')}"
                       @click="${ _ => this._toggleVersandKonfigDialog(true) }"
        ></isceco-button>
      `
    }
    return html``
  }

  _toggleVersandKonfigDialog(visible) {
    this._showVersandKonfigDialog = visible
    this.render()
  }

  _renderVersandKonfigDialog() {
    if (!this._showVersandKonfigDialog) {
      return html``
    }
    const aktiveKonfig = this.versandKonfigs.find(it => !it.archivedOn)
    const elektronisches = aktiveKonfig?.elektronisches
    const setupCallback = _ => {
      this._toggleVersandKonfigDialog(false)
      this.reload()
    }
    return html`
      <isceco-dialog id="versand-konfig-dialog"
                     @submit="${_ => this._toggleVersandKonfigDialog(false)}">
        <eko-frontend-gp-verfuegung-setup .sprache="${this.geschaeftspartner.sprache}"
                                          .elektronisches="${elektronisches}"
                                          .callback="${setupCallback}"
        ></eko-frontend-gp-verfuegung-setup>
      </isceco-dialog>
    `
  }

  _toggleEditSpracheDialog(visible) {
    this._showEditSpracheDialog = visible
    this.render()
  }

  _renderEditSpracheDialog() {
    if (!this._showEditSpracheDialog) {
      return html``
    }
    return html`
      <isceco-dialog id="sprache-anpassen-dialog"
                     header="${this.i18n.translate('gp.stammdaten.sprache.edit')}"
                     confirm-button="${this.i18n.translate('base.button.submit')}"
                     cancel-button="${this.i18n.translate('base.button.cancel')}"
                     @submit="${this._saveSprache}">
        <isceco-form id="sprache-anpassen-form">
          <div id="sprache-anpassen-content" slot="form-elements">
            <isceco-radio-group name="sprache"
                                value="${this.geschaeftspartner.sprache}"
                                .items="${[
                                  {value: 'DE', name: this.i18n.translate('gp.stammdaten.sprache.de')},
                                  {value: 'FR', name: this.i18n.translate('gp.stammdaten.sprache.fr')},
                                  {value: 'IT', name: this.i18n.translate('gp.stammdaten.sprache.it')}
                                ]}"
                                required
            ></isceco-radio-group>
          </div>
        </isceco-form>
      </isceco-dialog>
    `
  }

  getListData() {
    const elektronischeVerfuegung = this.geschaeftspartner.elektronischeVerfuegung
      ? this.i18n.translate('gp.stammdaten.eVerfuegung.ja')
      : this.i18n.translate('gp.stammdaten.eVerfuegung.nein')

    const sprache = this.geschaeftspartner.sprache
      ? this.i18n.translate(`gp.stammdaten.sprache.${this.geschaeftspartner.sprache.toLowerCase()}`)
      : undefined

    const vnbRow = new DetailRow(
      this.i18n.translate('gp.stammdaten.vnb'),
      this.geschaeftspartner.vnbName,
      new LinkCell({url: this.getVnbDetailUrl})
    )

    return [
      new DetailRow(this.i18n.translate('gp.stammdaten.id'), this.geschaeftspartner.id),
      new DetailRow(this.i18n.translate('gp.stammdaten.extId'), this.geschaeftspartner.extId),
      new DetailRow(this.i18n.translate('gp.stammdaten.uid'), this.geschaeftspartner.uid),
      new DetailRow(this.i18n.translate('gp.stammdaten.name'), this.geschaeftspartner.name),
      new DetailRow(this.i18n.translate('gp.stammdaten.verantwortlichePerson'), this.geschaeftspartner.verantwortlichePerson),
      new DetailRow(this.i18n.translate('gp.stammdaten.adresse'), this.geschaeftspartner.adresse),
      new DetailRow(this.i18n.translate('gp.stammdaten.kanton'), this.geschaeftspartner.kanton),
      new DetailRow(this.i18n.translate('gp.stammdaten.email'), this.geschaeftspartner.email, new EmailCell()),
      new DetailRow(this.i18n.translate('gp.stammdaten.telefon'), this.geschaeftspartner.telefon, new PhoneCell()),
      this.showVnb() ? vnbRow : null,
      new DetailRow(this.i18n.translate('gp.stammdaten.sprache'), sprache, new EditableCell({
        cell: new StringCell(),
        editCallback: new AuthorizationFilter().roles.GP ? this._editSprache : undefined
      })),
      new DetailRow(this.i18n.translate('gp.stammdaten.eVerfuegung'), elektronischeVerfuegung)
    ].filter(v => v)
  }

  showVnb() {
    const roles = new AuthorizationFilter().roles
    return roles.BWL || roles.OSTRAL
  }

  getVnbDetailUrl = () => constructURL({to: Navigation.ROUTES.vnbStammdaten.url, id: this.geschaeftspartner.vnbExtId})

  downloadVerfuegungKonfig = konfig => {
    const filename = `${this.geschaeftspartner.name} - ${formatDate(konfig.createdOn)}`
    this.gpService.read(getNavigationId(), `verfuegungversand/${konfig.id}/pdf`)
      .then(response => response.blob())
      .then(blob => download(toValidFilename(filename, 'pdf'), blob))
  }

  _editSprache = () => this._toggleEditSpracheDialog(true)
  _saveSprache = e => {
    if (!e.detail.confirmed) {
      this._toggleEditSpracheDialog(false)
      return
    }
    const form = document.getElementById('sprache-anpassen-form')
    if (form.validate()) {
      this._toggleEditSpracheDialog(false)
      const obj = form.getValues()
      obj.id = this.geschaeftspartner.extId
      this.gpService.update(obj).then( json => {
        this.geschaeftspartner = new GPDto(json)
        window.showAlert(this.i18n.translate('gp.stammdaten.sprache.saved'), "", 'success')
        this.reload()
      })
    }
  }
}

customElements.define('eko-frontend-gp-detail-stammdaten', GPStammdaten)
